export const NAME = "dashboard" as const;

export const LOCAL_STORAGE_COLLAPSIBLE_WIDGET_KEY = "widgets";
export const LOCAL_STORAGE_GROUP_BY_CHAIN_KEY = "groupByChain";
